/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_GInputs */

const en_tut_presence_g = /** @type {(inputs: Tut_Presence_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence answers the question distributed teams ask most: can this person be interrupted right now? The answer is built from the status you choose, your working hours, and the Indonesian holiday calendar.`)
};

const id_tut_presence_g = /** @type {(inputs: Tut_Presence_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence menjawab pertanyaan yang paling sering muncul di tim yang tersebar: orang ini sedang bisa diganggu atau tidak? Jawabannya disusun dari status yang Anda pilih, jam kerja Anda, dan kalender hari libur Indonesia.`)
};

/**
* | output |
* | --- |
* | "Presence answers the question distributed teams ask most: can this person be interrupted right now? The answer is built from the status you choose, your work..." |
*
* @param {Tut_Presence_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_g = /** @type {((inputs?: Tut_Presence_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_g(inputs)
	return en_tut_presence_g(inputs)
});